import { config } from '@/entities/wallet/api/wagmi.config';
import { AUTH_COOKIE_NAME } from '@/shared/api';
import '@/shared/i18n/i18n.config';
import usePreventZoom from '@/shared/lib/zoom';
import { Fallback } from '@/shared/ui';
import { ToastContainer } from '@/shared/ui/Toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { init, postEvent, useRawInitData } from '@telegram-apps/sdk-react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { Buffer } from 'buffer';
import Cookies from 'js-cookie';
import { default as React, Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import ErrorBoundary from '../../shared/hoc/ErrorBoundary';
import AppContent from './AppContent';

// postEvent('web_app_request_fullscreen');

// const log = console.log.bind(console, '[APP]:');
const queryClient = new QueryClient();
const tonManifestUrl = process.env.TONCONNECT_UI_PROVIDER;

const App: React.FC = () => {
	init();

	postEvent('web_app_setup_swipe_behavior', { allow_vertical_swipe: false });
	postEvent('web_app_set_header_color', { color: '#080024' });
	postEvent('web_app_setup_closing_behavior', { need_confirmation: true });
	const initRawData = useRawInitData();

	usePreventZoom();

	useEffect(() => {
		Cookies.set(AUTH_COOKIE_NAME, `Bearer ${initRawData}`);
	}, []);

	window.Buffer = Buffer;

	return (
		<Suspense fallback={<Fallback />}>
			<WagmiProvider config={config}>
				<QueryClientProvider client={queryClient}>
					<TonConnectUIProvider manifestUrl={tonManifestUrl}>
						<ErrorBoundary>
							<BrowserRouter>
								<AppContent />
							</BrowserRouter>
						</ErrorBoundary>
					</TonConnectUIProvider>
				</QueryClientProvider>
			</WagmiProvider>
			<ToastContainer />
		</Suspense>
	);
};

export default App;
